export default __webpack_public_path__ + "static/media/delete-red.ebe91729.svg";